<template>
  <div>
    <restaurant-statistics v-if="isRestaurantType" />
    <company-statistics v-else-if="isCompanyType" />
    <div v-else class="pa-6 text-center">
      <v-icon size="64" color="grey lighten-1">mdi-chart-areaspline</v-icon>
      <div class="text-h6 grey--text mt-4">{{ $t("routes.statistics") }}</div>
      <div class="text-body-2 grey--text text--lighten-1 mt-2">
        {{ $t("statistics_not_available") }}
      </div>
    </div>
  </div>
</template>

<script>
import RestaurantStatistics from "./RestaurantStatistics.vue";
import CompanyStatistics from "./CompanyStatistics.vue";

const RESTAURANT_TYPES = ["admin", "restaurant", "report"];
const COMPANY_TYPES = ["company"];

export default {
  name: "StatisticsPage",
  components: {
    RestaurantStatistics,
    CompanyStatistics,
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isRestaurantType() {
      return RESTAURANT_TYPES.includes(this.user?.type);
    },
    isCompanyType() {
      return COMPANY_TYPES.includes(this.user?.type);
    },
  },
};
</script>
